export const APP_PAGE_TITLE = 'Portal | LTN';
export const LS_NAMESPACE = 'lt-localstorage-space';
export const DEFAULT_DEBOUNCE_TIME = 800;
export const MODE_STATUS_DISPLAY = {
  LED: 'LED',
  TIMELINE: 'TIMELINE',
};

export * from './env.constants';
export * from './api.constants';
export * from './notify-api.constants';
export * from './routes.constants';
export * from './theme.constants';
export * from './user-roles.constants';
export * from './pagination.constants';
export * from './notifications.constants';
export * from './watch.constants';
export * from './monitoring.constants';
export * from './sorting.constants';
export * from './scheduling.constants';
export * from './channels.constants';
export * from './leaves.constants';
export * from './contacts.constants';
export * from './status.constants';
export * from './hardware.constants';
export * from './bookings.constants';
